export enum RfqType {
  BUY = 'BUY',
  SELL = 'SELL'
}

export enum RfqStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  CONTACTED = 'CONTACTED'
}

export interface Rfq {
  rfq_id: string
  project_id: string
  project_name: string
  tranche_size: number
  valuation: number
  type: RfqType
  status: RfqStatus
  terms: string
  logo: string
  created_at: string
}

export interface RfqsListResponse {
  page: number
  items: number
  total: number
  data: Rfq[]
}

export interface RfqsQueryParams {
  type?: RfqType
  limit?: number
  offset?: number
}

export interface RfqsApiResponse {
  success: boolean
  data: RfqsListResponse
  error?: string
}
